import { render, staticRenderFns } from "./RecentPendingProfile.vue?vue&type=template&id=7d855691"
import script from "./RecentPendingProfile.vue?vue&type=script&lang=js"
export * from "./RecentPendingProfile.vue?vue&type=script&lang=js"
import style0 from "./RecentPendingProfile.vue?vue&type=style&index=0&id=7d855691&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports